<template>
  <div
    v-if="costMinMax[0] !== null && costMinMax[1] !== null"
    class="plans-filter-price"
  >
    <div class="plans-filter-price__label">Стоимость, млн ₽</div>
    <CustomSlider
      v-model="costFilter"
      :min="costMinMax[0]"
      :max="costMinMax[1]"
      :format="costFilterFormat"
    />
  </div>
</template>

<script>
import CustomSlider from "@/components/CustomSlider.vue";
import _minBy from "lodash/minBy";
import _maxBy from "lodash/maxBy";

export default {
  components: {
    CustomSlider,
  },

  inject: ["filterStore"],

  props: {
    flats: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      costFilter: [null, null],
      costMinMax: [null, null],
    };
  },

  computed: {
    costFilterActive() {
      return this.filterStore.state.filterCost;
    },
  },

  watch: {
    flats: {
      handler(newFlats) {
        if (newFlats && newFlats.length > 0) {
          this.setCostMinMax(newFlats);
        }
      },
      immediate: true,
    },
    costFilter: {
      handler(newValue) {
        if (newValue[0] !== null && newValue[1] !== null) {
          this.filterStore.setFilterCost(newValue);
        }
      },
      deep: true,
    },
  },

  mounted() {
    if (this.flats.length > 0) {
      this.setCostMinMax(this.flats);
    }
    if (this.costFilterActive && this.costFilterActive[0] !== null) {
      this.costFilter = this.costFilterActive;
    }
  },

  methods: {
    costFilterFormat(value) {
      return (value / 1000000).toFixed(2);
    },

    setCostMinMax(flats) {
      if (flats && flats.length > 0) {
        let costMin = _minBy(flats, "discount_cost")?.discount_cost;
        let costMax = _maxBy(flats, "discount_cost")?.discount_cost;
        if (typeof costMin === "number" && typeof costMax === "number") {
          this.costMinMax = [costMin, costMax];
          if (!this.costFilterActive || this.costFilterActive[0] === null) {
            this.costFilter = [costMin, costMax];
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.plans-filter-price {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}

.plans-filter-price__label {
  font-weight: 500;
  font-size: 14px;
  color: #291f1f;
}

@media (max-width: 768px) {
  .plans-filter-price__label {
    font-size: 12px;
  }
}
</style>
